import { URLConstructor } from '../utils/URLBuilder'

export const moveToURL = (url: URLConstructor, shouldOpenInNewTab?: boolean): void => {
    if (shouldOpenInNewTab) {
        window.open(url.toString(), '_blank')?.focus()
    } else {
        window.location.href = url.constructURL()
    }
}
